<template>
  <div name="hrms-dropdown-month">
    <hrms-dropdown  v-model="inputValue"
                    :options="objMonth[nowLang]"
                    :disabled="disabled"
                    :showNone="false" />
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'hrms-dropdown-month',
  props: {
    value: {
      type: [String, Number],
      default () {
        return moment().month() - 1
      }
    },
    nowLang: {
      type: String,
      default: 'en'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      inputValue: this.value,
      objMonth: {
        'en': {
          '1': 'January',
          '2': 'February',
          '3': 'March',
          '4': 'April',
          '5': 'May',
          '6': 'June',
          '7': 'July',
          '8': 'August',
          '9': 'September',
          '10': 'October',
          '11': 'November',
          '12': 'December'
        },
        'th': {
          '1': 'มกราคม',
          '2': 'กุมภาพันธ์',
          '3': 'มีนาคม',
          '4': 'เมษายน',
          '5': 'พฤษภาคม',
          '6': 'มิถุนายน',
          '7': 'กรกฎาคม',
          '8': 'สิงหาคม',
          '9': 'กันยายน',
          '10': 'ตุลาคม',
          '11': 'พฤศจิกายน',
          '12': 'ธันวาคม'
        }
      }
    }
  },
  watch: {
    value () {
      this.inputValue = this.value
    },
    inputValue () {
      if (this.inputValue === undefined) {
        this.inputValue = 1
      }
      this.$emit('input', this.inputValue)
    }
  }
}
</script>


// WEBPACK FOOTER //
// component.vue?6f117920